import { ResolveFn } from '@angular/router';
import { moduleRouteResolver } from './module-route.resolver';

export const goalsResolver: ResolveFn<any> = moduleRouteResolver();
